// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const getPromptResponseQuery: any = graphql(`
  query getPromptResponse(
    $channel: String!
    $conversationId: String
    $expertId: String
    $inPreview: Boolean
    $prompt: String!
  ) {
    getPromptResponse(
      channel: $channel
      conversationId: $conversationId
      expertId: $expertId
      inPreview: $inPreview
      prompt: $prompt
    ) {
      references {
        id
        contentType
        name
        __typename
      }
      response
      conversationId
    }
  }
`);
